/*
These functions make sure WordPress
and Foundation play nice together.
*/

var $ = jQuery;

$(document).ready(function() {

    // Remove empty P tags created by WP inside of Accordion and Orbit
    $('.accordion p:empty, .orbit p:empty').remove();

    // Adds Flex Video to YouTube and Vimeo Embeds
    $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
        if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
            $(this).wrap("<div class='widescreen responsive-embed'/>");
        } else {
            $(this).wrap("<div class='responsive-embed'/>");
        }
    });

    var swiper = new Swiper(".swiper-slideshow", {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 0,
        autoplay: {
            delay: 3500,
            disableOnInteraction: true,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            640: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            },
        }
    });

    /** image and text snippet swiper slider **/
    var imgSlider = new Swiper('.__iats_image_slider', {
        loop: true,
        loopedSlides: 3,
        spaceBetween: 0,
        speed: 1500,
        allowTouchMove: false,
        navigation: {
            nextEl: '.swiper-btn-next',
            prevEl: '.swiper-btn-prev',
            },
    });

    var contentSlider = new Swiper('.__iats_content_slider', {
        loop: true,
        loopedSlides: 3,
        spaceBetween: 0,
        speed: 1500,
        allowTouchMove: false,
        navigation: {
            nextEl: '.swiper-btn-next',
            prevEl: '.swiper-btn-prev',
        },
    });

});
